import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { propertyDetailsApi } from "../../apis/propertydetails/propertyDetailsApi";


export const fetchPropertyDetails = createAsyncThunk(
  "fetchPropertyDetails",
  async (productId) => {
    try {
      const response = await propertyDetailsApi(productId);
      return response?.data?.data;
    } catch (error) {
      return null;
    }
  }
);

const propertyDetailsSlice = createSlice({
  name: "propertyList",
  initialState: {
    isLoading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPropertyDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPropertyDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });

    builder.addCase(fetchPropertyDetails.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export default propertyDetailsSlice.reducer;
